<template>
    <div>
        <div v-show="qrcode" class="animated slideInUp" style="z-index: 8000; position: absolute; width: 100%; height: 100%; display: none; background: #F0F0F0; border-top: 170px solid #2196F3;">
            
            <div class="container">
                <div class="row" style="margin-top: -60px;">
                    <div class="col-lg-2 col-xs-1"></div>
                    <div class="col-lg-8 col-xs-10" style="background: #FFF;  padding: 30px;  border-radius: 3px; box-shadow: 0 1px 1px 0 rgba(0,0,0,0.06), 0 2px 5px 0 rgba(0,0,0,0.2);">
                        <div class="row">
                            <div class="col-xs-12">
                                <div class="fechar"  @click="fechar" style=" margin-top: -20px;">
                                        <span style="float: right;margin-top: 16px;">{{_traducao('global', 'fechar')}} </span>
                                    <i class="icon-close fechar"></i> 
                                    
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-5 text-center">
                                <qrcode-vue :value="link" :size="size" level="H"></qrcode-vue>
                                <h5>QR Code</h5>
                            </div>

                            <div class="col-xs-7">
                                <h1 style="margin-top: 58px;">Followair</h1>
                                <!-- <h4>Utilize o Followair em seu telefone para ler o código.</h4> -->
                                <h4>{{_traducao('global', 'leiaQRCode')}}</h4>

                                <div style="margin-top:30px">
                                    <a href="https://play.google.com/store/apps/details?id=com.tsa.followair&hl=pt_BR"
                                        target="_blank"
                                        style="margin-right: 10px;margin-bottom: 10px;width: 166px;"
                                        class="btn btn-info btn-sm">
                                        <div class="row">
                                            <div class="col-xs-3 text-center">
                                                <i class="fa fa-android" style="font-size: 33px"></i>
                                            </div>
                                            <div class="col-xs-9 text-left">
                                                <h5 style="margin-top:0px; margin-bottom: 0px">{{_traducao('global', 'disponivelNa')}}</h5>
                                                <h4 style="margin-top:0px; margin-bottom: 0px">Google Play</h4>
                                            </div>
                                        </div>
                                    </a>

                                    <a href="https://itunes.apple.com/br/app/followair/id1296843769?mt=8"
                                        target="_blank"
                                        style="margin-bottom: 10px;width: 166px;"
                                        class="btn btn-info btn-sm">
                                        <div class="row">
                                            <div class="col-xs-3 text-center">
                                                <i class="fa fa-apple" style="font-size: 33px"></i>
                                            </div>
                                            <div class="col-xs-9 text-left">
                                                <h5 style="margin-top:0px; margin-bottom: 0px">{{_traducao('global', 'disponivelNa')}}</h5>
                                                <h4 style="margin-top:0px; margin-bottom: 0px">Apple Store</h4>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>

                            <div class="col-xs-12 text-center">
                                <img height="90" style="margin-top: 30px;" src="../../../assets/img/logo.png" alt="">
                            </div>
                        </div>
                        
                    </div>
                    <div class="col-xs-2"></div>
                </div>
            </div>
            
            
        </div>
    </div>
</template>

<script>
export default {

	props: ['link', 'show'],

	data (){
		return {
			qrcode: false,
			size: 200,
		}
	},

	watch: {
		'show': function(val, oldVal){
			if(val){
				this.qrcode = true
			} else {
				this.qrcode = false
			}
		}
	},
	methods: {
		fechar (){
			this.$emit('fechou')
		}
	}
}
</script>